document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(
    ".header__drawer .menu-drawer__link--has-submenu"
  );

  menuItems.forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();

      const parent = item.closest(".menu-drawer__list-item");
      const submenu = parent.querySelector(".menu-drawer__sublist");

      // close all open submenus
      document.querySelectorAll(".menu-drawer__sublist.open").forEach((el) => {
        if (el !== submenu) el.classList.remove("open");
      });

      submenu.classList.toggle("open");
      item.querySelector(".menu-drawer__icon").classList.toggle("open");
    });
  });


  document.querySelectorAll(".menu-drawer__menu-item--mainlist").forEach((item) => {
    const parent = item.closest("li");
    const submenu = parent.querySelector(".menu-drawer__menu--childlist");

    if (!submenu) return;

    item.addEventListener("click", (e) => {
      e.preventDefault();
      submenu.classList.toggle("open");
      item.querySelector(".menu-drawer__icon").classList.toggle("open");
    });
  });
});
